namespace('compass.hotel');

compass.require('compass.hotel.ReservationConfirmationWidget');
compass.requireLib('compass.util.format');

compass.hotel.StaySummaryWidget = compass.defineWidget(function StaySummaryWidget(options) {
	var me = this;
	var $j = jQuery;
	var d = jQuery.dom.getContext(this);
	var _settings = options;

	var _cf = _settings.meetingInfo.defaultCurrencyFormatter;

	var _stays = _settings.roomTypeRecap;

	this.render = function(widgetElem) {
		var summaryDiv = d.div({className:'summaryDiv'});
		summaryDiv.append(drawSummaryHeader());
		summaryDiv.append(d.div({className:'summaryDivider'}));
		for(var roomType=0; roomType<_stays.length; roomType++) {
			summaryDiv.append(
				drawRoomType(_stays[roomType]),
				drawRoomNights(_stays[roomType]),
				drawTotal(_stays[roomType]),
				drawViewLink(_stays[roomType]),
				d.div({className:'floatClear'}),
				d.div({className:'summaryDivider'})
			);
		}
		if(_stays.length > 1) {
			summaryDiv.append(drawAllTotal());
		}
		widgetElem.append(summaryDiv);
		var paperShadowDiv = d.div({className:'paperShadowDiv'});
		widgetElem.append(paperShadowDiv);
	};

	function drawSummaryHeader(){
		return d.div({className:'summaryHeader'}, 'Summary');
	}

	function drawRoomType(roomType) {
		return d.div({className: 'stayItem roomType'}, roomType.roomType.roomTypeName + ': ');
	}

	function drawRoomNights(roomType) {
		var roomNightString = roomType.totals.rooms + ' rooms, ' + roomType.totals.roomNights + ' nights';
		return d.div({className:'stayItem roomNightsStay'}, roomNightString);
	}

	function drawTotal(roomType) {
		var totalString = 'Estimated Total: ' + _cf(roomType.totals.cost + roomType.totals.serviceFee);
		return d.div({className:'stayItem itemTotal'}, totalString);
	}

	function drawAllTotal(){
		var totalCost = 0;
		for (var resType=0; resType<_stays.length; resType++) {
			totalCost = totalCost + _stays[resType].totals.cost + _stays[resType].totals.serviceFee;
		}
		var allTotalString = 'Total amount of stay: ' + _cf(totalCost);
		return d.div({className:'stayItem allItemTotal'}, allTotalString);
	}

	function drawViewLink(roomType){
		var linkDiv = d.div({className:'resLinkDiv'}, d.a({
				href: "javascript:;"
			}, "View details &raquo;"));

		jQuery(linkDiv).activate(function() {
			var popup = d.div();
			var resConfirmData = {
				WUID : 'ReservationDetails_' + _settings.WUID,
				meetingInfo : _settings.meetingInfo,
				stayRecap : roomType.stays,
				roomType : roomType.roomType,
				stays: roomType.stays,
				nights: roomType.nights,
				includeControls: false
				};

			var resConfirmWidget = new compass.hotel.ReservationConfirmationWidget(popup, resConfirmData);
			_confirmDialog = d.dialog({
				classes : 'confirmationDialog',
				modal : true,
				contents : popup,
				showParent : true
				});

		});
		return linkDiv;

	}

}, {
	WUID : 'defaultStaySummaryWidgetWUID',
	widgetName : 'StaySummaryWidget'
});

